import { useRef } from "react";

const useCounterRef = (initialCount = 0) => {
  const counter = useRef(initialCount);

  return {
    getCurrentCount: () => counter.current,
    incrementCounter: () => counter.current += 1,
    decrementCounter: () => counter.current -= 1
  };
};

export default useCounterRef;
